import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { APIResponse } from '../_types/api-responses.types';
import { CarMakers, VehiclesReponse } from '../_types/vehicle.type';

@Injectable({
  providedIn: 'root',
})
export class VehicleInfoService {
  insurancebaseURL: string;

  constructor(private httpClient: HttpClient) {
    this.insurancebaseURL = environment.INSURANCEAPIURL;
  }

  getBrands(date: Date) {
    return this.httpClient.get<APIResponse<CarMakers>>(
      `${this.insurancebaseURL}car/manufacturers`,
      {
        params: {
          month: date.getMonth().toString(),
          year: date.getFullYear().toString(),
        },
      }
    );
  }

  getModels(brandName: string, date: Date) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/models`,
      {
        params: {
          month: (date.getMonth() + 1).toString(),
          year: date.getFullYear().toString(),
          brandName,
        },
      }
    );
  }

  getModelsByCertificateId(certificateId: string, date: Date) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/models/certificate`,
      {
        params: {
          certificateId,
          month: date.getMonth().toString(),
          year: date.getFullYear().toString(),
        },
      }
    );
  }

  getVehicleByAutoId(autoId: string, year: number) {
    return this.httpClient.get<APIResponse<VehiclesReponse>>(
      `${this.insurancebaseURL}car/details`,
      {
        params: {
          autoId,
          year,
        },
      }
    );
  }
}
